const ENABLED_CATEGORY_IDS = [
  27108, // 27108 - WW / New In / New In: View All
  2623, // 2623 - WW / New In / Clothing
  4169, // 4169 - WW / Clothing / Tops
  8799, // 8799 - WW / Clothing / Dresses

  5775, // 51137 - MW / Shoes, boots & trainers | trainers
  27110, // 27110 - MW / New In / New In: View All
  3606, // 6993 - MW /Jackets and coats
  7616, // 7616 - MW / Clothing / T-shirts & Vests
  5668 // 5668 - MW / Clothing / Hoodies & Sweatshirts
];

const shouldEnableBanner = ({
  categoryId,
  isEarlyAccessSaleAvailable,
  isEarlyAccessSaleEventActive,
  storeCode
}) =>
  ENABLED_CATEGORY_IDS.includes(categoryId) &&
  isEarlyAccessSaleAvailable &&
  isEarlyAccessSaleEventActive &&
  storeCode === "COM";

export default shouldEnableBanner;
